export const pdfLayoutsByCountry = {
  signature: {
    fr: {
      signaturePage: {
        contractNumber: { x: 77.5, y: 566, size: 12 },
        signatureDate: { x: 80, y: 513, size: 12 },
        sellerName: { x: 42, y: 325, size: 11 },
        timeStampt: { x: 289, y: 325, size: 12 },
        ip: { x: 478, y: 326, size: 10.5 },
        dealerEmail: { x: 60, y: 195, size: 12 },
      },
    },
    de: {
      signaturePage: {
        contractNumber: { x: 77.5, y: 566, size: 12 },
        signatureDate: { x: 80, y: 513, size: 12 },
        sellerName: { x: 42, y: 325, size: 11 },
        timeStampt: { x: 289, y: 325, size: 12 },
        ip: { x: 478, y: 326, size: 10.5 },
        dealerEmail: { x: 60, y: 195, size: 12 },
      },
    },
    uk: {
      signaturePage: {
        contractNumber: { x: 77.5, y: 566, size: 12 },
        signatureDate: { x: 80, y: 513, size: 12 },
        sellerName: { x: 42, y: 325, size: 11 },
        timeStampt: { x: 289, y: 325, size: 12 },
        ip: { x: 478, y: 326, size: 10.5 },
        dealerEmail: { x: 60, y: 195, size: 12 },
      },
    },
  },

  facture: {
    fr: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 242, y: 1129, size: 19 },
      customerName: { x: 202, y: 1064.5, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },

    de: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 235, y: 1145, size: 19 },
      customerName: { x: 244, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
    uk: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 231, y: 1145, size: 19 },
      customerName: { x: 230, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
    se: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 238, y: 1145, size: 19 },
      customerName: { x: 220, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
    no: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 238, y: 1145, size: 19 },
      customerName: { x: 211, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
    dk: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 238, y: 1145, size: 19 },
      customerName: { x: 211, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
    jp: {
      date: { x: 228, y: 1193, size: 19 },
      contractNumber: { x: 231, y: 1145, size: 19 },
      customerName: { x: 230, y: 1080, size: 19 },
      products: {
        startY: 945,
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 20 },
        productPrice: { x: 838, size: 21 },
        totalPriceExclVat: { x: 140, y: 232, size: 24 },
        vatRate: { x: 530, y: 232, size: 24 },
        totalAmountIcnlVat: { x: 613, y: 232, size: 24 },
        netAmount: { x: 836, y: 232, size: 24 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 80, y: 20, size: 20 },
        name: { x: 140, y: 22, size: 18 },
        serialNumber: { x: 613, size: 17 },
        accessoryPrice: { x: 838, size: 21 },
      },
    },
  },
  privacyNotice: {
    uk: {
      date: { x: 186, y: 614, size: 10 },
      customerEmail: { x: 186, y: 655, size: 10 },
      customerName: { x: 186, y: 640, size: 10 },
      dealerName: { x: 186.5, y: 585, size: 10 },
    },
    se: {
      date: { x: 186.5, y: 664, size: 10 },
      customerEmail: { x: 186.5, y: 705, size: 10 },
      customerName: { x: 186.5, y: 688, size: 10 },
      dealerName: { x: 186.5, y: 640, size: 10 },
    },
    no: {
      date: { x: 186.5, y: 664, size: 10 },
      customerEmail: { x: 186.5, y: 705, size: 10 },
      customerName: { x: 186.5, y: 688, size: 10 },
      dealerName: { x: 186.5, y: 640, size: 10 },
    },
    dk: {
      date: { x: 186.5, y: 664, size: 10 },
      customerEmail: { x: 186.5, y: 705, size: 10 },
      customerName: { x: 186.5, y: 688, size: 10 },
      dealerName: { x: 186.5, y: 640, size: 10 },
    },
    jp: {
      date: { x: 186, y: 614, size: 10 },
      customerEmail: { x: 186, y: 655, size: 10 },
      customerName: { x: 186, y: 640, size: 10 },
      dealerName: { x: 186.5, y: 585, size: 10 },
    },
  },

  hireAgreement: {
    uk: {
      contractNumber: { x: 200, y: 595, size: 11 },
      customerName: { x: 200, y: 555, size: 11 },
      totalMonthlyFee: { x: 200, y: 513, size: 11 },
      contractLength: { x: 200, y: 472, size: 11 },
      products: {
        startY: 430,
        rowHeight: 16,
        name: { x: 200, size: 10 },
      },
      accessories: {
        rowHeight: 40,
        quantity: { x: 200, y: 20, size: 10 },
        name: { x: 200, y: 22, size: 10 },
      },
      customerNameParagraph: { x: 429, y: 226.5, size: 11.5 },
    },
  },
  /// LEASEPLUS ///

  leaseplus: {
    se: {
      currency: "SEK",
      firstPage: {
        totalMonthlyFee: { x: 444, y: 402, size: 21 },
        currencyPosition: {
          x: { 2: 472, 3: 483, 4: 500, 5: 513 },
          y: 402,
          size: 10,
        },
        date: {
          x: 485,
          y: 350.5,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 742.6, size: 21.5 },
        contractLength: { x: 96, y: 727.2, size: 8 },
        currencyPosition: {
          x: { 2: 68, 3: 80, 4: 97, 5: 110, 6: 120 },
          y: 743,
          size: 9,
        },
        date: {
          x: 80,
          y: 708,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 761, size: 8 },
          customerEmail: { x: 174.5, y: 751, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 338.5, y: 761, size: 8 },
          dealerEmail: { x: 339, y: 751, size: 8 },
        },
        products: {
          startY: 637,
          size: 7.5,
          rowHeight: 16.2,
          quantity: { x: 45 },
          name: { x: 83 },
          services: { x: 337, size: 7.5 },
          answer: { x: 485 },
        },
        accessories: {
          startY: 461,
          size: 7.5,
          rowHeight: 16.2,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },

    no: {
      currency: "NOK",
      firstPage: {
        totalMonthlyFee: { x: 443, y: 406.5, size: 21 },
        currencyPosition: {
          x: { 2: 472, 3: 482, 4: 500, 5: 512.5, 6: 522 },
          y: 408,
          size: 10,
        },
        date: {
          x: 481,
          y: 355.7,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 737, size: 20 },
        currencyPosition: {
          x: { 2: 68, 3: 78, 4: 96, 5: 106, 6: 115 },
          y: 738,
          size: 9,
        },
        contractLength: { x: 113, y: 720, size: 8 },
        date: {
          x: 54,
          y: 692.5,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 760, size: 8 },
          customerEmail: { x: 174.5, y: 750, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 342, y: 760, size: 8 },
          dealerEmail: { x: 342.5, y: 750, size: 8 },
        },
        products: {
          startY: 625,
          size: 7.5,
          rowHeight: 15,
          quantity: { x: 45 },
          name: { x: 84 },
          services: { x: 338, size: 7.5 },
          answer: { x: 487 },
        },
        accessories: {
          startY: 462,
          size: 7.5,
          rowHeight: 15,
          quantity: { x: 45 },
          name: { x: 85 },
        },
      },
    },

    dk: {
      currency: "KR.",
      firstPage: {
        totalMonthlyFee: { x: 443, y: 406.5, size: 21 },
        currencyPosition: {
          x: { 2: 472, 3: 483, 4: 500, 5: 512, 6: 522 },
          y: 408,
          size: 12,
        },
        date: {
          x: 478,
          y: 354,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 743, size: 20 },
        currencyPosition: {
          x: { 2: 68, 3: 79, 4: 95, 5: 107, 6: 117 },
          y: 743,
          size: 11,
        },
        contractLength: { x: 98, y: 727.5, size: 8 },
        date: {
          x: 74,
          y: 696.5,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 173.8, y: 761, size: 8 },
          customerEmail: { x: 174.5, y: 751, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 356.3, y: 761, size: 8 },
          dealerEmail: { x: 357, y: 751, size: 8 },
        },
        products: {
          startY: 629,
          size: 7.5,
          rowHeight: 15.5,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 355, size: 7.5 },
          answer: { x: 504 },
        },
        accessories: {
          startY: 447,
          size: 7.5,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 83 },
        },
      },
    },
    de: {
      firstPage: {
        totalMonthlyFee: { x: 452, y: 401, size: 21 },
        date: {
          x: 459,
          y: 350.5,
          size: 10,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 90, y: 742, size: 21 },
        contractLength: { x: 93, y: 727, size: 8 },
        date: {
          x: 74,
          y: 708,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 186, y: 759.5, size: 7.5 },
          customerEmail: { x: 186.5, y: 750, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 433.5, y: 759.5, size: 7.5 },
          dealerEmail: { x: 434, y: 750, size: 8 },
        },
        products: {
          startY: 623,
          size: 7.5,
          rowHeight: 15.5,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 351.5, size: 7.5 },
          answer: { x: 492 },
        },
        accessories: {
          startY: 441,
          size: 7.5,
          rowHeight: 15,
          quantity: { x: 45 },
          name: { x: 83 },
        },
      },
    },
    fr: {
      firstPage: {
        totalMonthlyFee: { x: 455.5, y: 401.5, size: 21 },
        date: {
          x: 493,
          y: 355,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 56, y: 742, size: 22 },
        contractLength: { x: 102.5, y: 727.2, size: 8 },
        date: {
          x: 87.5,
          y: 707.8,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 761, size: 8 },
          customerEmail: { x: 174.5, y: 751, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 354, y: 761, size: 8 },
          dealerEmail: { x: 354.5, y: 751, size: 8 },
        },
        products: {
          startY: 632,
          size: 7.5,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 353, size: 7.5 },
          answer: { x: 493 },
        },
        accessories: {
          startY: 453,
          size: 7.5,
          rowHeight: 16.3,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },
    nl: {
      firstPage: {
        totalMonthlyFee: { x: 456, y: 400, size: 21 },
        date: {
          x: 491,
          y: 346.5,
          size: 9.5,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 56, y: 707.5, size: 22.5 },
        contractLength: { x: 88.5, y: 692.5, size: 8 },
        date: {
          x: 82,
          y: 673,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 726.5, size: 8 },
          customerEmail: { x: 174.5, y: 716, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 336, y: 726.5, size: 8 },
          dealerEmail: { x: 336.5, y: 716, size: 8 },
        },
        products: {
          startY: 598,
          size: 7.2,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 82 },
          services: { x: 334, size: 7.5 },
          answer: { x: 488 },
        },
        accessories: {
          startY: 426,
          rowHeight: 15.5,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },
    uk: {
      firstPage: {
        totalMonthlyFee: { x: 457, y: 396, size: 22 },
        date: {
          x: 439,
          y: 346,
          size: 9.5,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 54, y: 742, size: 22 },
        contractLength: { x: 95, y: 727.5, size: 8 },
        date: {
          x: 44,
          y: 708,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 761, size: 8 },
          customerEmail: { x: 174, y: 751, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 356.8, y: 761, size: 8 },
          dealerEmail: { x: 356.8, y: 751, size: 8 },
        },
        products: {
          startY: 632,
          size: 7.5,
          rowHeight: 15.6,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 353, size: 7.5 },
          answer: { x: 495, size: 7.5 },
        },
        accessories: {
          startY: 445,
          size: 7.5,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },
  },

  upcare: {
    uk: {
      firstPage: {
        totalMonthlyFee: { x: 456, y: 403, size: 20 },
        savings: { x: 479, y: 392, size: 7.5 },
        regularPrice: {
          x: 454.5,
          y: 368.5,
          size: 16,
          line: {
            x1: 440,
            y1: 373.5,
            x2: { 3: 510, 4: 525 },
            y2: 373.5,
            thickness: 1,
          },
        },

        date: {
          ceoraCampaign: { x: 438, y: 356, size: 9.5 },
          ceoraCampaignDiscount: { x: 438, y: 310, size: 9 },
          x: 438,
          y: 356,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 54, y: 742, size: 22 },
        contractLength: { x: 95, y: 727.5, size: 8 },
        date: {
          ceoraCampaign: { x: 44.5, y: 708, size: 8 },
          x: 44,
          y: 708,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 174, y: 759.5, size: 7.5 },
          customerEmail: { x: 174.5, y: 750, size: 8 },
          companyNumber: { x: 174, y: 740, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 434, y: 759.5, size: 7.5 },
          dealerEmail: { x: 434.5, y: 750, size: 8 },
        },
        products: {
          startY: 632,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 353 },
          answer: { x: 495 },
        },
        accessories: {
          startY: 444,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },
    se: {
      currency: "SEK",
      firstPage: {
        totalMonthlyFee: { x: 443, y: 406.5, size: 21 },
        savings: { x: 482.5, y: 393.5, size: 7.5 },
        currencyPosition: {
          x: { 2: 472, 3: 481, 4: 497.5, 5: 512 },
          y: 406,
          size: 10,
        },
        regularPrice: {
          x: 443.5,
          y: 374,
          size: 16,
          currencyPosition: {
            x: { 2: 472, 3: 481, 4: 486, 5: 497 },
            y: 374.5,
            size: 10,
          },
          line: {
            x1: 441,
            y1: 378,
            x2: { 3: 510, 4: 518, 5: 525 },
            y2: 378,
            thickness: 1,
          },
        },
        date: {
          ceoraCampaign: { x: 438, y: 363, size: 10 },
          ceoraCampaignDiscount: { x: 450, y: 323.5, size: 9 },
          x: 486,
          y: 362,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 743, size: 20 },
        currencyPosition: {
          x: { 2: 69, 3: 77, 4: 95, 5: 108 },
          y: 743,
          size: 9,
        },
        contractLength: { x: 95, y: 727.5, size: 8 },
        date: {
          ceoraCampaign: { x: 44.5, y: 708, size: 8 },
          x: 80,
          y: 708,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 173, y: 759, size: 7.5 },
          customerEmail: { x: 174, y: 750, size: 8 },
          companyNumber: { x: 173.5, y: 740, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 435.5, y: 759.5, size: 7.5 },
          dealerEmail: { x: 436.5, y: 750, size: 8 },
        },
        products: {
          startY: 641,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 83 },
          services: { x: 340 },
          answer: { x: 482 },
        },
        accessories: {
          startY: 468,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 84 },
        },
      },
    },
    no: {
      currency: "NOK",
      firstPage: {
        totalMonthlyFee: { x: 443, y: 406.5, size: 21 },
        currencyPosition: {
          x: { 2: 472, 3: 481, 4: 500, 5: 511 },
          y: 405,
          size: 10,
        },
        date: {
          ceoraCampaign: { x: 438, y: 361, size: 10 },
          x: 481,
          y: 359.5,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 738, size: 20 },
        currencyPosition: {
          x: { 2: 68, 3: 78, 4: 96, 5: 106 },
          y: 740,
          size: 9,
        },
        contractLength: { x: 113, y: 719.5, size: 8 },
        date: {
          ceoraCampaign: { x: 43.2, y: 693, size: 8 },
          x: 54,
          y: 692.5,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 173.2, y: 759, size: 7.5 },
          customerEmail: { x: 173.8, y: 750, size: 8 },
          companyNumber: { x: 173, y: 740, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 434, y: 759.5, size: 7.5 },
          dealerEmail: { x: 434.5, y: 750, size: 8 },
        },
        products: {
          startY: 615,
          rowHeight: 16,
          quantity: { x: 45 },
          name: { x: 84 },
          services: { x: 338 },
          answer: { x: 485 },
        },
        accessories: {
          startY: 445,
          rowHeight: 15.5,
          quantity: { x: 45 },
          name: { x: 85 },
        },
      },
    },
    dk: {
      currency: "KR.",
      firstPage: {
        totalMonthlyFee: { x: 442.5, y: 407, size: 21 },
        currencyPosition: {
          x: { 2: 472, 3: 483, 4: 498.5, 5: 512 },
          y: 407,
          size: 11,
        },
        date: {
          ceoraCampaign: { x: 438, y: 359, size: 9 },
          x: 477,
          y: 360.5,
          size: 9,
        },
      },
      secondPage: {
        totalMonthlyFee: { x: 42, y: 743, size: 20 },
        currencyPosition: {
          x: { 2: 69, 3: 80, 4: 96, 5: 108 },
          y: 743,
          size: 10,
        },
        contractLength: { x: 98, y: 727.5, size: 8 },
        date: {
          ceoraCampaign: { x: 45, y: 696.5, size: 8 },
          x: 74,
          y: 696.5,
          size: 8,
        },
        customerInfo: {
          customerName: { x: 173.3, y: 759, size: 7.5 },
          customerEmail: { x: 174, y: 750, size: 8 },
          companyNumber: { x: 173.5, y: 740, size: 8 },
        },
        dealerInfo: {
          dealerName: { x: 436.5, y: 759.5, size: 7.5 },
          dealerEmail: { x: 437, y: 750, size: 8 },
        },
        products: {
          startY: 630,
          rowHeight: 15,
          quantity: { x: 45 },
          name: { x: 82.5 },
          services: { x: 356 },
          answer: { x: 508 },
        },
        accessories: {
          startY: 462,
          rowHeight: 15,
          quantity: { x: 45 },
          name: { x: 83 },
        },
      },
    },
  },
};
